import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const apiKey = "4ebb6c8a-a9b6-4cb6-ac38-1765cd00ff4a";

// redux/createApi.js
export const automotorApi = createApi({
  reducerPath: "automotorApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://api.apicar.store/api/",
    prepareHeaders: (headers) => {
      headers.set("api-key", apiKey);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getCars: builder.query({
      query: ({ page = 1, size = 10, make = "", site = "" }) => {
        const url = `cars?page=${page}&size=${size}${make !== "" ? `&make=${make}` : ""}${site !== "" ? `&site=${site}` : ""
          }`;
        return url;
      },
    }),
    getCarsFilter: builder.query({
      query: (params_obj) => {
        const {
          page = 1,
          size = 12,
          "search-type": searchType,
          lot_id,
          type,
          make,
          model,
          "year-from": yearFrom,
          "year-to": yearTo,
          "auction-type": auctionType,
        } = params_obj;

        const params = new URLSearchParams({
          page: page.toString(),
          size: size.toString(),
        });

        if (searchType) params.append("search-type", searchType);
        if (lot_id) params.append("title", lot_id);
        if (type) params.append("vehicle_type", type);
        if (make) params.append("make", make);
        if (model) params.append("model", model);
        if (yearFrom) params.append("year_from", yearFrom);
        if (yearTo) params.append("year_to", yearTo);
        if (auctionType) params.append("site", auctionType);

        return `cars?${params.toString()}`;
      },
    }),
    getCarsFilterTab: builder.query({
      query: ({ page = 1, size = 10, vehicle_type = "" }) => {
        const url = `cars?page=${page}&size=${size}&vehicle_type=${vehicle_type}`;
        return url;
      },
    }),
    getCarSaleHistory: builder.query({
      query: (lot_id) => ({
        url: `sale-histories/lot-id`,
        params: { lot_id },
      }),
    }),
  }),
});

export const {
  useGetCarsQuery,
  useGetCarsFilterQuery,
  useGetCarsFilterTabQuery,
  useGetCarSaleHistoryQuery,
} = automotorApi;
